import SwitchTab from "../../components/Reusable/SwitchTab";
import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import useGetHook from "../../customHooks/useGetHook";
import { useState } from "react";
import Spinner from "../../components/Reusable/Spinner";
const ConfigurationComponent = loadable(
  () => import("../../components/Configuration")
);

const Configuration = () => {
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["configuration"],
  });

  const { data, isLoading } = useGetHook({
    queryKey: ["number-series", `number-series-${selectedType}`],
    url: APIS.NUMBER_SERIRES,
    params: {
      type: selectedType,
    },
  });

  const handleCreate = async (values, setError) => {
    const url = APIS.NUMBER_SERIRES;
    const formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const tabs = [
    { id: "settings", label: "Profile", href: "/accounting/profile" },
    {
      id: "configuration",
      label: "Configuration",
      href: "/accounting/configuration",
    },
    {
      id: "setting",
      label: "Setting",
      href: "/accounting/settings",
    },
    {
      id: "settings-ird",
      label: "Setting IRD",
      href: "/accounting/settings-ird",
    },
  ];
  return (
    <div>
      <SwitchTab tabs={tabs} />
      {isLoading ? (
        <Spinner />
      ) : (
        <ConfigurationComponent
          handleCreate={handleCreate}
          isLoading={isPostLoading}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
          data={data}
        />
      )}
    </div>
  );
};

export default Configuration;

